export default "__VITE_ASSET__PAfQjbwU__"